import { OrganizationEntity } from '../types';

export const ORG_STATE_UPDATED = 'ORG_STATE_UPDATED';

export interface BaseUpdateOrgRequest {
    orgId: string;
}

export interface InviteTeamRequest extends BaseUpdateOrgRequest {
    emails: string[];
}

export interface OrgStateUpdatedAction {
    type: typeof ORG_STATE_UPDATED;
    payload: OrganizationEntity;
}

// Action Creators

export const orgStateUpdated: (payload: OrganizationEntity) => OrgStateUpdatedAction = (payload) => {
    return {
        type: ORG_STATE_UPDATED,
        payload,
    };
};
